import {makeAutoObservable} from 'mobx';
import {MainPageStoreInterface} from "utils/interface/MainPage";
import {mainPageConfigDefault} from "./constants";

const defaultMainPageStoreDate: MainPageStoreInterface = {
    mainPageConfig: {}
}
class Store {
    mainPageConfig

    constructor(mainPageStore: MainPageStoreInterface) {
        makeAutoObservable(
            this,
            {

            },
            {
                autoBind:true
            }
        );
        this.mainPageConfig = mainPageStore.mainPageConfig
    }

    async getMainPageConfig(businessId: string): Promise<void> {
        this.mainPageConfig = mainPageConfigDefault
    }

}

const MainPageStore = new Store(defaultMainPageStoreDate);

export default MainPageStore;